"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalPerson = void 0;
class LegalPerson {
}
exports.LegalPerson = LegalPerson;
//# sourceMappingURL=LegalPerson.js.map